import React, { useState, useMemo, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { getGasCriterion } from 'redux/action/criterion';
import { EditableCriterionTable } from 'utils/table/EditableCriterionTable';
import columns from './columns';
import { updateCriterionDataValidate } from 'utils/validate/updateCriterionDataValidate';
import { customAxiosGetFunction, customAxiosPostFunction } from 'utils/axiosFunction';

import { Styles } from 'utils/table/Table.css.js';
import './GasCriterionButtonBar.css';

const GasCriterion = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [criterionList, setCriterionList] = useState([]);
  const [data, setData] = useState([]);
  const column = useMemo(() => columns, []);

  const getCriterion = async () => {
    const response = await customAxiosGetFunction(history, '/api/gasCriterion/getAllData');
    setCriterionList(response);
  };

  useEffect(() => {
    getCriterion();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    
    const tableData = criterionList.filter((x) => x.criterionIdx !== 6).map((d, index) => {
      return {
        rnum: index + 1,
        ...d,
        criterionValueList: d.criterionValueList.map((data) => {
          return {
            ...data,
            criterionIdx: d.criterionIdx,
          };
        }),
        statusName: index + 1 === 5 && props.flag === "0" ? "CH4" : d.statusName,
      };
    });

    setData(tableData);
  }, [criterionList]);

  const updateDataSave = useCallback(() => {
    if (updateCriterionDataValidate(data)) {
      alert('관리기준 설정은 숫자만 입력');
      return false;
    }

    customAxiosPostFunction(history, '/api/gasCriterion/update', data).then((response) => {
      if (response) {
        alert('저장완료');
        dispatch(getGasCriterion());
        getCriterion();
      } else {
        alert('업데이트실패');
      }
    });
  }, [data]);

  return (
    <section>
      <Styles tableType="editable">
          <EditableCriterionTable columns={column} data={data} setData={setData}>
            <div className="buttonBar-conatiner">
              <div className="form-row">
                <div className="button-condition col-xl-1 col-sm-6">
                  <button type="button" className="table-button-submit btn btn-info" onClick={getCriterion}>
                    초기화
                  </button>
                </div>
                <div className="button-condition col-xl-1 col-sm-6">
                  <button type="button" className="table-button-submit btn btn-info" onClick={updateDataSave}>
                    저장
                  </button>
                </div>
              </div>
            </div>
          </EditableCriterionTable>
      </Styles>
    </section>
  );
};

export default GasCriterion;
